import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Modal } from '@tinper/next-ui';
import './style/index'

export default class CommonPicker extends Component {
  static propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    bodyClassName: PropTypes.string, // Modal body className

    width: PropTypes.string | PropTypes.number, // 模态框宽度，如只传数字则会拼接默认单位 px
    height: PropTypes.string | PropTypes.number, // 模态框内容高度，如只传数字则会拼接默认单位 px
    
    cancelText: PropTypes.string, // 取消按钮文字
    okText: PropTypes.string, // 确认按钮文字
    closable: PropTypes.bool, // 是否显示右上角的关闭按钮
    isShowHeader: PropTypes.bool, // 是否展示头部区域
    title: PropTypes.string, // 标题
    visible: PropTypes.bool, // 对话框是否可见
    close: PropTypes.func, // 点击右上角叉或取消按钮的回调
    okClick: PropTypes.func, // 点击确定回调
  };

  state = {
    visible: this.props.visible
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ visible: nextProps.visible });
  }

  // 关闭弹窗
  onCancel = () => {
    this.props.close ? this.props.close(this.close) : this.close();
  }

  close = () => {
    this.setState({ visible: false });
  }

  // 确定
  onClick = () => {
    this.props.okClick?.(this.close)
    this.close()
  }

  getFieldId = () => {
    const { fieldid, fieldidPrefix } = this.props || {};
    return fieldid || fieldidPrefix;
  };

  render() {
    const { render, children, style, className, getPopupContainerDom, alias, ...others } = this.props;

    return (
      <>
        <Modal
          visible={this.state.visible}
          destroyOnClose={true}
          maskClosable={false}
          onCancel={this.onCancel}
          onOk={this.onClick}
          style={style}
          className={className}
          getPopupContainer={() => document.querySelector(getPopupContainerDom)}
          {...others}
          fieldid={`${this.getFieldId()}`}
        >
          <Modal.Body>
            <div className='ref-view'>
              { children }
            </div>
          </Modal.Body>
        </Modal>
      </>
    )
  }
}
